import { queryKeys } from "@/lib/queryKeys";
import createAgendaItemDataToSDKMapper from "@/mappers/agenda/createAgendaItemDataMapper";
import {
    CreateAgendaItemData,
    useAgenda,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useErrorToast from "../utils/useErrorToast";

const useCreateAgendaEvent = (onSuccess?: () => void) => {
    const agenda = useAgenda();
    const showError = useErrorToast();
    const queryClient = useQueryClient();

    const createAgendaEvent = useMutation<
        void,
        unknown,
        { createAgendaItemData: CreateAgendaItemData }
    >({
        mutationFn: async ({ createAgendaItemData }) => {
            const createDataToSDK =
                createAgendaItemDataToSDKMapper(createAgendaItemData);

            const created = await agenda.createAgendaItem(createDataToSDK);

            if (!created) {
                throw new Error("Agenda item creation refused by the provider");
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.agendaEvents.all(),
            });
            onSuccess?.();
        },
        onError: (error) => {
            console.error(error);
            showError({
                titleTranslationKey: "errors.agenda.create",
            });
        },
    });

    return { createAgendaEvent };
};

export default useCreateAgendaEvent;
